export default "__VITE_ASSET__DAFj44GP__"